import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { HttpService } from '../../../services/http.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-user-feedback',
  templateUrl: './user-feedback.component.html',
  styleUrls: ['./user-feedback.component.scss']
})
export class UserFeedbackComponent implements OnInit {

  id: number;
  datas = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private httpService: HttpService,
    private translate: TranslateService,
    private title: Title
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.translate.use(sessionStorage.getItem('language'));
    }
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.id = parseInt(params.get('id'), 0);
    });
    let txtArea, txtFeedback;
    this.translate.get('Area').subscribe((res) => {
      txtArea = res;
    });
    this.translate.get('Feedback').subscribe((res) => {
      txtFeedback = res;
    });
    setTimeout(() => {
      this.title.setTitle(txtArea + ' ' + this.id + ' ' + txtFeedback + ' | Hushcity');
    }, 200);
    let lang = 'en';
    if (isPlatformBrowser(this.platformId)) {
      lang = sessionStorage.getItem('language');
    }
    this.httpService.getQuestion(this.id, lang)
      .subscribe((data) => {
        if (data.err_code === 0) {
          data.data.survey.forEach((question) => {
            question.section_name = question.section_name.replace(/questions/gi, 'REPLIES');
            // let newAnswer;
            question.questions.forEach((ques) => {
              if (ques.type === 'rate') {
                const options = ques.options.split('|-|');
                if (options[0].trim() === 'Not quiet' || options[0].trim() === 'Very quiet') {
                  if (ques.t_answer === '1' || ques.t_answer === '1.0') {
                    ques.t_answer = 'Not quiet';
                  } else if (ques.t_answer === '2' || ques.t_answer === '2.0') {
                    ques.t_answer = 'Slightly quiet';
                  } else if (ques.t_answer === '3' || ques.t_answer === '3.0') {
                    ques.t_answer = 'Fairly quiet';
                  } else if (ques.t_answer === '4' || ques.t_answer === '4.0') {
                    ques.t_answer = 'Quiet';
                  } else if (ques.t_answer === '5' || ques.t_answer === '5.0') {
                    ques.t_answer = 'Very quiet';
                  }
                }
                if (options[0].trim() === 'Not much' || options[0].trim() === 'Very much') {
                  if (ques.t_answer === '1' || ques.t_answer === '1.0') {
                    ques.t_answer = 'Not much';
                  } else if (ques.t_answer === '2' || ques.t_answer === '2.0') {
                    ques.t_answer = 'Slightly much';
                  } else if (ques.t_answer === '3' || ques.t_answer === '3.0') {
                    ques.t_answer = 'Fairly much';
                  } else if (ques.t_answer === '4' || ques.t_answer === '4.0') {
                    ques.t_answer = 'Much';
                  } else if (ques.t_answer === '5' || ques.t_answer === '5.0') {
                    ques.t_answer = 'Very much';
                  }
                }
                if (options[0].trim() === 'Not good' || options[0].trim() === 'Very good') {
                  if (ques.t_answer === '1' || ques.t_answer === '1.0') {
                    ques.t_answer = 'Not good';
                  } else if (ques.t_answer === '2' || ques.t_answer === '2.0') {
                    ques.t_answer = 'Slightly good';
                  } else if (ques.t_answer === '3' || ques.t_answer === '3.0') {
                    ques.t_answer = 'Fairly good';
                  } else if (ques.t_answer === '4' || ques.t_answer === '4.0') {
                    ques.t_answer = 'Good';
                  } else if (ques.t_answer === '5' || ques.t_answer === '5.0') {
                    ques.t_answer = 'Very good';
                  }
                }
                this.translate.get(ques.t_answer).subscribe((res) => {
                  ques.t_answer = res;
                });
              }
              /* newAnswer = ques.t_answer.split('|-|');
              if (newAnswer.length > 0 && newAnswer[0] !== '') {
                for (let i = 0; i < newAnswer.length; i++) {
                  this.translate.get(newAnswer[i].trim()).subscribe((res) => {
                    newAnswer[i] = res;
                  });
                }
              }
              ques.t_answer = newAnswer.join(', '); */
              if (ques.reply === '') {
                question.questions.splice(question.questions.indexOf(ques));
              }
              if (ques.reply !== '' && ques.reply !== ' ') {
                this.translate.get(ques.reply).subscribe((res) => {
                  ques.reply = res;
                });
              }
            });
            this.datas.push(question);
          });
        } else {
          console.log(data);
        }
      });
  }

  backDetail() {
    this.location.back();
  }

}
